import { IconContext } from '../icon-text/interfaces';

export interface DroplistPopupConfig {

	/**
	 * Provide an instructional messsage to be displayed above the droplist
	 * in the popup. e.g. "Select a Person"
	 */
	message: string,

	/**
	 * Optionally change the icon displayed in the button.
	 * Default: "{ icon: "fa-regular fa-arrows-alt-h", color:"#666" }"
	 */
	iconContext: IconContext,

}


export const DEFAULT_POPUP_CONFIG: DroplistPopupConfig = {
	message: 'Select an Item...',
	iconContext: {
		iconClass: 'fa-left-right color-darkgray',
		iconStyle: 'fa-regular',
		text: 'Select an Item...',
		hideText: 'always',
	}
};